import { render, staticRenderFns } from "./ClosingUsulan.vue?vue&type=template&id=3674697c&lang=pug&"
import script from "./ClosingUsulan.vue?vue&type=script&lang=js&"
export * from "./ClosingUsulan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports